import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    ColorItems: [],
};

const colorSlice = createSlice({
    name: 'Color',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getColorSuccess(state, action) {
            state.isLoading = false;
            state.ColorItems = action.payload;
        },
    },
});

export default colorSlice.reducer;

export const { startLoading, hasError, getColorSuccess } = colorSlice.actions;

export const getAllColors = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/Color/get-all-Color');
        dispatch(getColorSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addColor = (Color) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const response = await axios.post('attributes/Color/Color-add', {
            Color,
            AddedBy: `${currentUser?.firstName} ${currentUser?.lastName}`,
        })
        dispatch(getAllColors());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteColor = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/Color/Color-delete/${id}`);
        dispatch(getAllColors());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateColor = (Color, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/Color/Color-update/${id}`, {
            Color,
        });
        dispatch(getAllColors());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};